import {createReducer, Reducer} from "redux-act";
import {IRoundReducer} from "modules/types";
import {fetchRoundSuccessAction} from "modules/actions/jsons";

const initialState: IRoundReducer = [];
export const rounds: Reducer<IRoundReducer> = createReducer({}, initialState);
rounds.on(fetchRoundSuccessAction, (state, payload) => [...payload]);
